var React = require('react');

function AddedIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"16","fill":"#FB6902","key":0}),React.createElement("path",{"d":"M19.2133 20H20.8513V10.662H18.5413L15.9933 16.948L13.4593 10.662H11.1493V20H12.7873V12.93L15.6433 20H16.3433L19.2133 12.93V20Z","fill":"white","key":1})]);
}

AddedIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = AddedIcon;

AddedIcon.default = AddedIcon;
